var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 16.717 18.7341 20.6712 14.3402 21.7247M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.4233 2 14.7772 2.29736 16.0029 2.83333M17.5297 3.66667C17.7778 3.83164 18.0181 4.00741 18.25 4.19329M19.5 5.38544C20.1436 6.11465 20.6825 6.93846 21.0933 7.83333C21.3957 8.49236 21.6287 9.18994 21.7827 9.91667",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.f9c23309be85ba0bdcbed9f318fff2b6.svg";
export { ForwardRef as ReactComponent };